import React, {Component} from 'react';
import './Searchbox.css';
import Octicon, {Search} from '@githubprimer/octicons-react';
import $ from 'jquery';
import {ajax} from '../../../Context';

const AJAX_TYPE = '135796';

class Searchbox extends Component {
    constructor(props) {
        super(props);
        this.state = {
            searchword: '',
            width: window.innerWidth,
            height: window.innerHeight
        };
        this.changeSearchword = this.changeSearchword.bind(this);
        this.handleSearchRequest = this.handleSearchRequest.bind(this);
    }

    changeSearchword(event) {
        this.setState({
            searchword: event.target.value
        });
    }

    handleSearchRequest(event) {
        this.props.resetSearch();
        this.props.changeRoute('search');
        event.preventDefault();
        $.ajax({
           url:ajax.url,
            type: 'POST',
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded'
            },
            dataType: 'json',
            data: {
                'type': AJAX_TYPE,
                'searchword': this.state.searchword,
                'uhash': this.props.hash,
                'w': this.state.width
            },
            cache: false,
            success: function (data) {
                this.props.setResults(data);
                this.props.setLastsearch(this.state.searchword);
                this.setState({
                    searchword:''
                });
                this.props.changeRoute('search');
            }.bind(this),
            error: function() {
                this.props.resetSearch();
                this.setState({
                    searchword:''
                });
                this.props.changeRoute('search');
            }.bind(this)
        });
    }


    render() {
        let count;
        if(this.props.results !== null && this.props.route === 'search') {
            if(this.props.results.count > 0) {
                count = (
                    <p className="search-info">
                        Für die Suchanfrage '{this.props.lastSearchword}' wurden {this.props.results.count} Treffer gefunden.
                    </p>
                )
            }else{
                count = (
                    <p className="search-info">
                        Für die Suchanfrage '{this.props.lastSearchword}' wurden keine Treffer gefunden.
                    </p>
                )
            }

        }
        return <div className="Search">
            <form method="POST" onSubmit={(event) => this.handleSearchRequest(event)}>
                <label htmlFor="searchword" className="sr-only">
                    Suchwort
                </label>
                <div className="form-group">
                    <input type="text" name="searchword" id="searchword" className="search-input form-control" placeholder="Suchbegriff eingeben" value={this.state.searchword} onChange={(event) => this.changeSearchword(event)} />
                    <button type="submit" className="search-icon"><Octicon icon={Search} /></button>
                </div>
                {count}
            </form>
        </div>
    }
}

export default Searchbox;


// WEBPACK FOOTER //
// ./src/Components/Search/Searchbox/Searchbox.js